import React, { useState, useEffect, Fragment } from "react";

import {
  Form,
  Input,
  Button,
  Popconfirm,
  message,
  Table,
  Tag,
  Space,
  Select,
  Tooltip,
  Modal,
} from "antd";

import {
  DeleteFilled,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./NewsList.module.less";

const { Option } = Select;

function NewsList({ navigate, location }) {
  const { state } = location;

  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [visible, setVisible] = useState(false);
  const [reason, setReason] = useState(null);
  const [data, setData] = useState({});
  const [brandList, setBrandList] = useState([]);
  const [search, setSearch] = useState(state?.search ? state?.search : {});
  const [pagination, setPagination] = useState(
    state?.pagination
      ? state?.pagination
      : {
        current: 1,
        pageSize: 10,
        total: 0,
      }
  );

  const [form] = Form.useForm();

  const columns = [
    {
      title: "编号",
      dataIndex: "id",
      key: "id",
      ellipsis: true,
      width: 120,
    },
    {
      title: "文章标题",
      dataIndex: "",
      key: "x",
      ellipsis: true,
      render: (data) => (
        <a href={data.url} title={data.title} target="_blank">
          {data.title}
        </a>
      ),
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      ellipsis: true,
      width: 180,
      render: (_, data) => (
        <Space>
          {piStatus(data)}
          {piTop(data)}
        </Space>
      ),
    },
    {
      title: "所属网站",
      dataIndex: ["site", "name"],
      key: ["site", "name"],
      ellipsis: true,
      width: 160,
    },
    {
      title: "所属栏目",
      dataIndex: ["child", "name"],
      key: ["child", "name"],
      ellipsis: true,
      width: 160,
    },
    {
      title: "收录",
      dataIndex: "include",
      key: "include",
      ellipsis: true,
      width: 260,
      render: (_, data) => {
        return (
          <Fragment>
            <Tag color={data.baidu === 0 ? null : "blue"}>百度</Tag>
            <Tag color={data.so === 0 ? null : "green"}>360</Tag>
            <Tag color={data.sogou === 0 ? null : "red"}>搜狗</Tag>
            <Tag color={data.sm === 0 ? null : "orange"}>神马</Tag>
          </Fragment>
        );
      },
    },
    {
      title: "创建日期",
      dataIndex: "createdTime",
      key: "createdTime",
      ellipsis: true,
      width: 180,
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      width: 120,
      render: (_, data) => (
        <Button
          type="link"
          size="small"
          onClick={() => {
            navigate(`save`, { state: { data, search, pagination } });
          }}
        >
          编辑
        </Button>
      ),
    },
  ];

  const piTop = (value) => {
    if (value.asTop === 1) return <Tag color="orange">已置顶</Tag>;
    return null;
  };

  const piStatus = (value) => {
    if (value.status === 0)
      return (
        <Tooltip title={value.reviewMsg}>
          <Tag color="red">已驳回</Tag>
        </Tooltip>
      );
    if (value.status === 1) {
      return (
        <Tooltip title={value.banMsg}>
          <Tag color="blue">审核中</Tag>
        </Tooltip>
      );
    }
    if (value.status === 2) return <Tag color="blue">草稿箱</Tag>;
    if (value.status === 3) return <Tag color="green">已发布</Tag>;
    return null;
  };

  const onSearch = (values) => {
    if (values.kw) {
      values.kw = values.kw.replace(/\s+/g, "");
    }
    setSearch(values);
    onLoading({
      search: values,
      pagination: { current: 1, pageSize: 10, total: 0 },
    });
  };

  const onDelete = async (id) => {
    let para = queryString.stringify({ id });
    try {
      let parsed = await Http.post(`news/delete`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onLoading({ search, pagination });
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const onPass = async (id) => {
    let para = queryString.stringify({ id: id, status: 3 });
    try {
      let parsed = await Http.post(`news/review`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onLoading({ search, pagination });
        setVisible(false);
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const onRefuse = async (id) => {
    if (reason) {
      let para = queryString.stringify({
        id: id,
        status: 2,
        reviewMsg: reason,
      });
      try {
        let parsed = await Http.post(`news/review`, {
          body: new URLSearchParams(para),
        }).json();
        if (parsed.state === "ok") {
          await message.success(parsed.message ? parsed.message : "提交成功");
          onLoading({ search, pagination });
          setVisible(false);
        } else {
          await message.warn(parsed.message ? parsed.message : "提交失败");
        }
      } catch (error) {
        await message.error("接口调用错误, 错误原因:" + error.message);
      } finally {
      }
    } else {
      message.warn("请填写驳回原因！");
    }
  };

  const getNewsList = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`news`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setData(parsed.result);
      setSelected([]);
      setPagination({
        current: parsed.result.pageNumber,
        pageSize: parsed.result.pageSize,
        total: parsed.result.totalRow,
      });
    }
  };

  const getBrandList = async () => {
    let para = queryString.stringify({});
    let parsed = await Http.get(`brand/list`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setBrandList(parsed.result);
    }
  };

  const onLoading = async (params) => {
    console.log(111);
    setLoading(true);
    try {
      await getNewsList({
        ...params.search,
        pageNumber: params.pagination.current,
        pageSize: params.pagination.pageSize,
      });
      await getBrandList();
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onLoading({ search, pagination });
  }, []);

  return (
    <div className={styles.NewsList}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {selected.length > 0 ? (
            <Space>
              <Popconfirm
                title="是否确认全部删除?"
                onConfirm={() => {
                  onDelete(selected);
                }}
              >
                <Button type="primary" danger icon={<DeleteFilled />}>
                  删除
                </Button>
              </Popconfirm>
              <Button
                type="primary"
                danger
                icon={<CloseCircleFilled />}
                onClick={() => {
                  setReason(null);
                  setVisible(true);
                }}
              >
                驳回
              </Button>
              <Popconfirm
                title="是否确认全部通过?"
                onConfirm={() => onPass(selected)}
              >
                <Button type="primary" icon={<CheckCircleFilled />}>
                  通过
                </Button>
              </Popconfirm>
            </Space>
          ) : null}
        </div>
        <div className={styles.headerRight}>
          <Form
            initialValues={search}
            form={form}
            layout="inline"
            onFinish={onSearch}
          >
            <Form.Item name="kw" style={{ width: 240 }}>
              <Input placeholder="请输入关键词" />
            </Form.Item>
            <Form.Item name="status">
              <Select
                placeholder="请选择状态"
                style={{ width: 120 }}
                allowClear
              >
                <Option value="0">已驳回</Option>
                <Option value="1">审核中</Option>
                <Option value="2">草稿箱</Option>
                <Option value="3">已发布</Option>
              </Select>
            </Form.Item>
            <Form.Item name="asTop">
              <Select placeholder="请选择置顶" style={{ width: 120 }}>
                <Option value="0">未置顶</Option>
                <Option value="1">已置顶</Option>
              </Select>
            </Form.Item>
            <Form.Item name="brandId">
              <Select placeholder="请选择品牌" style={{ width: 120 }}>
                {brandList.map((value) => (
                  <Option key={value.id} value={String(value.id)}>
                    {value.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="reset"
                onClick={() => {
                  form.resetFields();
                }}
              >
                重置
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className={styles.content}>
        <Table
          loading={loading}
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selected,
            onChange: (srk) => {
              setSelected(srk);
            },
          }}
          onChange={(p, f, s) => {
            let sort = null;
            if (s.order) {
              sort = `${s.field} ${s.order.replace("end", "")}`;
            }
            onLoading({ search: { ...search, sort }, pagination: p });
          }}
          dataSource={data.list}
          columns={columns}
          pagination={pagination}
        />
      </div>
      <Modal
        title="请填写驳回原因"
        visible={visible}
        onOk={() => onRefuse(selected)}
        onCancel={() => {
          setVisible(false);
        }}
      >
        <Input.TextArea
          placeholder="请输入填写原因"
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </Modal>
    </div>
  );
}
export default NewsList;
